import script from "./3pLink200.vue?vue&type=script&setup=true&lang=js"
export * from "./3pLink200.vue?vue&type=script&setup=true&lang=js"

import "./3pLink200.vue?vue&type=style&index=0&id=3b3c6553&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3c6553"]])

export default __exports__